var exports = {
  "k": "xdde3148b--9e39b9--container",
};

module.exports = exports;
